export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/transcode.worker.aa9b8caf.worker.js");
}
